// import React, { useEffect } from "react";
import img1 from "../../../assets/gps/vehicleTracking.png";
import img2 from "../../../assets/gps/vehicleTracking2.png";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { Swiper, SwiperSlide } from "swiper/react";
// import { Navigation, Pagination, Autoplay } from "swiper/modules";
// import "swiper/css";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
// const images = [img1, img2];
// const VehicleTracking = () => {
//   useEffect(() => {
//     AOS.init({
//       duration: 1000,
//       once: false,
//       offset: 100,
//       delay: 200,
//     });
//   }, []);
//   return (
//     <div className="mx-8 lg:mx-12 py-10">
//       <Swiper
//         modules={[Navigation, Pagination, Autoplay]}
//         spaceBetween={30}
//         slidesPerView={1}
//         navigation
//         pagination={{ clickable: true }}
//         autoplay={{ delay: 3000, disableOnInteraction: false }}
//         loop={true}
//         // className="rounded-xl shadow-lg"
//       >
//         {images.map((image, index) => (
//           <SwiperSlide key={index}>
//             <img
//               src={image}
//               alt={`Banner ${index + 1}`}
//               className="w-full h-auto rounded-xl bg-cover"
//             />
//           </SwiperSlide>
//         ))}
//       </Swiper>
//     </div>
//   );
// };

// export default VehicleTracking;
import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

function VehicleTracking() {
  return (
    <div className="mx-8 lg:mx-12 py-10">
      <Swiper
        // spaceBetween={30}
        centeredSlides={true}
        autoplay={{
          delay: 2500,
          disableOnInteraction: false,
        }}
        pagination={{
          clickable: true,
        }}
        navigation={true}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
          <img src={img1} alt="" className="object-contain w-full bg-cover" />
        </SwiperSlide>
        <SwiperSlide>
          <img src={img2} alt="" className="object-contain w-full bg-cover" />
        </SwiperSlide>
      </Swiper>
    </div>
  );
}

export default VehicleTracking;
